import { render, staticRenderFns } from "./BosAdminDocumentForm.vue?vue&type=template&id=70f9d044&scoped=true"
import script from "./BosAdminDocumentForm.vue?vue&type=script&lang=js"
export * from "./BosAdminDocumentForm.vue?vue&type=script&lang=js"
import style0 from "./BosAdminDocumentForm.vue?vue&type=style&index=0&id=70f9d044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f9d044",
  null
  
)

export default component.exports